





























































































import { ProfileVueGB } from "@/extensions/profile/ProfileVueGB";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";
import BackLink from "@/components/app/BackLink.vue";
import OperationModal from "@/components/history/OperationModal.vue";
import Preloader from "@/components/app/Preloader.vue";


@Component({
  components: { 
    VerifyBox, 
    BackLink, 
    OperationModal,
    Preloader
  },
})
export default class ReferencesModal extends ProfileVueGB {

  async mounted() {
    if (!this.referencesList.length)
      await this.getReferences();
    this.operationsList = await this.getOpeationsList();
    if (this.operationsList && this.operationsList.length > 0) {
      this.operationsList = this.operationsList.filter((operation: any) => operation.Category === 'Справки')
    }
  }

  navigateToOperation(catalogId: number, index: number, showcaseId: number = 0) {
    if (showcaseId !== 0) {
      // Перенаправляем на страницу витрины с заданным ShowcaseId
      this.$router.push(`/showcase/${showcaseId}`);
      return;
    }

    const baseUri = `/operation/0/${catalogId}`;
    if (index === 0 && this.$route.params.contractId) {
      this.$router.push(`${baseUri}?contract=${this.$route.params.contractId}`);
    } else { 
      this.$router.push(baseUri) 
    }
  }
}
